"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CoreDataTables_1 = require("./CoreDataTables");
var Logger_1 = require("./../Core/Logger");
require("./JQueryExtensions");
(function (w, $) {
    if (!$)
        return false;
    var dataTablesExtension = {
        coreDataTableV2: function (options) {
            var obj = $(this);
            if (options == null) {
                options = {};
            }
            if (options.url == null) {
                options.url = $(obj).data('datatable-url');
            }
            if (options.connxtAllowExport == null) {
                options.connxtAllowExport = $(obj).data('connxt-allow-export');
            }
            if (options.parameters == null) {
                options.parameters = $(obj).data('parameters');
            }
            if (options.connxtAllowSelect == null) {
                options.connxtAllowSelect = $(obj).data('connxt-allow-select');
            }
            if (options.serverSide == null) {
                options.serverSide = $(obj).data('server-side');
            }
            if (options.connxtTableid == null) {
                options.connxtTableid = $(obj).data('connxt-tableid');
            }
            if (options.renderButtonsHeader == null) {
                options.renderButtonsHeader = $(obj).data('render-buttons-header');
            }
            if (options.connxtAllowToggleColumnVisibility == null) {
                options.connxtAllowToggleColumnVisibility = $(obj).data('connxt-allow-toggle-column-visibility');
            }
            if (options.columns == null) {
                var rawJsonColumns = $(obj).data('datatable-columns');
                if (rawJsonColumns != null) {
                    var jsonColumns = JSON.stringify(rawJsonColumns);
                    var columns = JSON.parse(jsonColumns, function (key, value) {
                        if (value && (typeof value === 'string') && value.indexOf("function") === 0) {
                            var jsFunc = new Function('return ' + value)();
                            return jsFunc;
                        }
                        return value;
                    });
                    options.columns = columns;
                }
            }
            var coreDataTable = new CoreDataTables_1.CoreDataTableV2(obj, options);
            if ($(obj).data('table-initialized') != 'true') {
                coreDataTable.Create();
            }
            return coreDataTable;
        },
        coreDataTable: function (options) {
            return this.each(function () {
                var obj = $(this);
                if (options == null) {
                    options = {};
                }
                if (options.url == null) {
                    options.url = $(obj).data('datatable-url');
                }
                if (options.pageLength == null) {
                    options.pageLength = $(obj).data('datatable-pagelength');
                }
                if (options.processing == null) {
                    options.processing = $(obj).data('datatable-processing');
                }
                if (options.serverSide == null) {
                    options.serverSide = $(obj).data('datatable-serverside');
                }
                if (options.columns == null) {
                    var rawJsonColumns = $(obj).data('datatable-columns');
                    if (rawJsonColumns != null) {
                        var jsonColumns = JSON.stringify(rawJsonColumns);
                        var columns = JSON.parse(jsonColumns, function (key, value) {
                            if (value && (typeof value === 'string') && value.indexOf("function") === 0) {
                                var jsFunc = new Function('return ' + value)();
                                return jsFunc;
                            }
                            return value;
                        });
                        options.columns = columns;
                    }
                }
                var rawJsonColumnDefs = $(obj).data('datatable-columndefs');
                if (rawJsonColumnDefs != null) {
                    if (options.columnDefs == null)
                        options.columnDefs = [];
                    var jsonColumnDefs = JSON.stringify(rawJsonColumnDefs);
                    var columnDefs = JSON.parse(jsonColumnDefs);
                    options.columnDefs = options.columnDefs.concat(columnDefs);
                }
                if (options.order == null) {
                    var rawJsonOrder = $(obj).data('datatable-order');
                    if (rawJsonOrder != null) {
                        var jsonOrder = JSON.stringify(rawJsonOrder);
                        var order = JSON.parse(jsonOrder);
                        options.order = order;
                    }
                }
                if (options.stateSave == null) {
                    options.stateSave = $(obj).data('datatable-statesave');
                    if (options.stateSave === true) {
                        options.stateSaveCallback = function (settings, data) {
                            localStorage.setItem('DataTables_' + settings.sInstance, JSON.stringify(data));
                            console.log('Write settings: ' + JSON.stringify(data));
                        };
                        options.stateLoadCallback = function (settings) {
                            return JSON.parse(localStorage.getItem('DataTables_' + settings.sInstance));
                        };
                    }
                    options.stateDuration = $(obj).data('datatable-stateduration');
                }
                if ($(obj).prop('tagName').toLowerCase() != 'table') {
                    obj = $('table', $(obj));
                }
                else {
                    Logger_1.Logger.error('Element is not a table or does not contain a table element.');
                }
                var coreDataTable = new CoreDataTables_1.CoreDataTable(obj, options);
                coreDataTable.Create();
            });
        }
    };
    $.fn.extend(dataTablesExtension);
})(window, $);
